module.exports = __webpack_public_path__ + "img/Image 2.69168a93.svg";